import React from "react";
import "./LegalPages.css";

const CondicionesUso = () => (
  <div className="legal-page">
    <h1>Condiciones de Uso</h1>

    <section>
      <h2>1. Titularidad del sitio web</h2>
      <p>
        El presente sitio web, <b>www.sparklingtech.es</b>, es propiedad de Sparkling Tech Solutions, S.L., con CIF B19364702, domicilio en Las Palmas de Gran Canaria, y correo electrónico de contacto: <a href="mailto:info@sparklingtech.es">info@sparklingtech.es</a>.
      </p>
    </section>

    <section>
      <h2>2. Aceptación de las condiciones</h2>
      <p>
        El acceso y/o uso de este sitio web atribuye la condición de Usuario, y supone la aceptación plena y sin reservas de las presentes condiciones.
      </p>
    </section>

    <section>
      <h2>3. Uso del contenido</h2>
      <p>
        Todos los contenidos del sitio web (textos, imágenes, logotipos, código fuente, etc.) están protegidos por derechos de propiedad intelectual e industrial. Queda prohibida su reproducción total o parcial sin autorización expresa del titular.
      </p>
      <p>
        El Usuario se compromete a utilizar los contenidos de forma lícita y respetuosa, y a no realizar ningún uso no autorizado que infrinja derechos del titular o de terceros.
      </p>
    </section>

    <section>
      <h2>4. Responsabilidad del Usuario</h2>
      <p>
        El Usuario se compromete a hacer un uso adecuado de los contenidos y servicios, y a no emplearlos para actividades ilícitas, contrarias a la buena fe o al orden público. El titular no se responsabiliza del uso indebido que los usuarios puedan hacer del sitio.
      </p>
    </section>

    <section>
      <h2>5. Exclusión de garantías y responsabilidad</h2>
      <p>
        El titular no garantiza la disponibilidad, continuidad ni infalibilidad del funcionamiento del sitio web y excluye, en la medida permitida por la legislación vigente, cualquier responsabilidad por daños y perjuicios derivados de su uso.
      </p>
    </section>

    <section>
      <h2>6. Enlaces externos</h2>
      <p>
        Este sitio web puede contener enlaces a sitios web de terceros. <b>Sparkling Tech Solutions, S.L.</b> no se hace responsable del contenido, políticas o prácticas de privacidad de dichos sitios.
      </p>
    </section>

    <section>
      <h2>7. Modificaciones</h2>
      <p>
        <b>Sparkling Tech Solutions, S.L.</b> se reserva el derecho a modificar, en cualquier momento y sin previo aviso, la presentación y configuración del sitio web, así como las presentes condiciones de uso.
      </p>
    </section>

    <section>
      <h2>8. Legislación y jurisdicción aplicable</h2>
      <p>
        Las presentes condiciones se rigen por la legislación española. Cualquier controversia se someterá a los Juzgados y Tribunales de Las Palmas de Gran Canaria, salvo que la ley disponga lo contrario.
      </p>
    </section>

    <p style={{ fontSize: "14px", marginTop: "10px",  color: "rgba(0, 0, 0, 0.6)" }}>Fecha de actualización 04/08/2025</p>
  </div>
);

export default CondicionesUso;
